module.exports = __webpack_public_path__ + "static/media/banner-post3.06f165dc.jpg";